<template>
    <dx-drop-down-box
        :data-source="dataSource"
        value-expr="dataField"
        display-expr="shortName"
        placeholder="Показывать всех"
        v-model:value="dropDownBoxValue"
        width="420"
        :showDropDownButton="true"
        :opened="isDropDownBoxOpened"
        :display-value-formatter="displayValueFormatter"
        drop-down-button-template="imageIcon"
        @closed="onDropDownClose"
        @opened="onDropDownOpened"
    >
        <template #imageIcon="{}">
            <img alt="Filter" :src="'/infoenergo/assets/filter.svg'" />
        </template>
        <template #content>
            <dx-form @field-data-changed="filterParamsChange">
                <dx-simple-item
                    v-for="field in formData"
                    :key="field.id"
                    :data-field="field.dataField"
                    :label="{ text: field.label, visible: false }"
                    :editor-options="{ text: field.label, value: field.value }"
                    editor-type="dxCheckBox"
                />
            </dx-form>
            <div class="custom-filter-form-button flex justify-end">
                <ai-button
                    text="Применить"
                    :style="{ minWidth: '120px', height: '30px' }"
                    @click="handleSubmit"
                />
            </div>
        </template>
    </dx-drop-down-box>
</template>

<script setup>
import { ref, reactive, defineEmits } from 'vue';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { DxForm, DxSimpleItem } from 'devextreme-vue/form';
import AiButton from '@/components/ai-button/ai-button.vue';

const props = defineProps({
    dataSource: {
        type: Object,
        default: () => {
        },
    },
});

const formData = reactive({ ...props.dataSource });

const isDropDownBoxOpened = ref(false);

const emit = defineEmits(['updateFilters']);

const formFieldsState = ref({});

const setInitialValues = source => {
    const initialValues = [];
    for (const obj of source) {
        if (obj.value) {
            initialValues.push(obj.dataField);
        }
    }
    return initialValues;
};

const dropDownBoxValue = ref(setInitialValues(props.dataSource));

const filterParamsChange = event => {
    formFieldsState.value[event.dataField] = event.value;
};

const handleSubmit = () => {
    const selectedFilters = [];
    for (const key in formFieldsState.value) {
        if (formFieldsState.value[key] === true) {
            selectedFilters.push(key);
        }
    }

    emit('updateFilters', selectedFilters);

    dropDownBoxValue.value = selectedFilters;
    isDropDownBoxOpened.value = false;
};

const displayValueFormatter = value => {
    if (value.length === 3) {
        return 'Показывать всех';
    }

    if (value.length > 0) {
        return 'Показывать:  ' + value.join(', ');
    }

    return value;
};

const onDropDownClose = () => {
    isDropDownBoxOpened.value = false;
};

const onDropDownOpened = () => {
    isDropDownBoxOpened.value = true;
};
</script>

<style lang="scss" scoped>
:deep(.dx-button-text) {
    text-transform: none;
}
</style>
